module.exports = __webpack_public_path__ + "static/media/gallery.da74a811.svg";